(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('enumFilterValue', enumFilterValue);

    function enumFilterValue(lodash, $filter) {
        return {
            restrict: 'EA',
            scope: {
                filterValueModel: '=',
                options: '=?',
                type: '=',
                settingsOverride: '=?',
                filterValueLabel: '=?',
                subSettings: '=?',
            },
            controller: enumFilterValueCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/components/filter-values-type/enum',
            link: function (scope, $timeout) {

                if ($filter('isMultipleEnumType')(scope.vm.type)) {
                    // morph options
                    // scope.vm.options = lodash.reduce(
                    //     lodash.get(scope.vm, 'options.data', {}),
                    //     function (accum, oData, oDataKey) {
                    //         lodash.set(accum, oDataKey, { data: oData });
                    //         return accum;
                    //     },
                    //     {}
                    // );

                    lodash.forEach(scope.vm.subFilterKeys, function (subFilterKey) {
                        if (!lodash.has(scope.vm.filterValueModel, subFilterKey)) {
                            lodash.set(scope.vm.filterValueModel, subFilterKey, null)
                        }

                        scope.$watch(function () {
                            return lodash.get(scope.vm.filterValueModel, subFilterKey)
                        }, function (newValue, oldValue) {
                            if (lodash.get(scope.vm.filterValueModel, subFilterKey)
                                && (newValue !== oldValue)
                                && (typeof lodash.get(scope.vm.filterValueLabel, subFilterKey) !== typeof undefined)
                            ) {
                                var selectedOption = lodash.find(lodash.get(scope.vm.ds, subFilterKey), { value: newValue });
                                lodash.set(scope.vm.filterValueLabel, subFilterKey, selectedOption.label);
                            }
                        })
                    });
                } else {
                    scope.$watch(function () {
                        return scope.vm.filterValueModel;
                    }, function (newValue, oldValue) {
                        if (scope.vm.filterValueModel && (newValue !== oldValue) && (typeof scope.vm.filterValueLabel !== typeof undefined)) {
                            var selectedOption = lodash.find(scope.vm.ds, {value: newValue});
                            scope.vm.filterValueLabel = selectedOption.label;
                        }
                    });
                }
            }
        };
    }

    function enumFilterValueCtrl(FbSelectService, lodash, GenericModel, $timeout, $scope, $filter) {
        var vm = this;

        var filterValueLabelPath = 'filterValueLabel';
        var filterValueModelPath = 'filterValueModel';
        var subSettingsPath = 'subSettings';
        var selectizePath = 'selectize';
        var isLoadingPath = 'isLoading';
        var optionsPath = 'options';
        var configPath = 'config';
        var dsPath = 'ds';
        this.$onInit = function() {
            if ($filter('isMultipleEnumType')(vm.type)) {
                var subSettingsWithOrder = Object.keys(vm.subSettings).map(function(subSettingKey) {
                    var subSetting = lodash.get(vm.subSettings, subSettingKey);
                    return {key: subSettingKey, order: lodash.get(subSetting, 'order', 9999)};
                });
                var subSettingsWithOrderSorted = lodash.orderBy(subSettingsWithOrder, ['order', 'asc']);
                vm.subFilterKeys = lodash.map(subSettingsWithOrderSorted, function(subSettingWithOrderSorted) {
                    return lodash.get(subSettingWithOrderSorted, 'key');
                });

                // morph options
                var vmOptionsKeys = Object.keys(vm.options);
                var uniqueValueKeys = lodash.xor(vmOptionsKeys, vm.subFilterKeys);
                var hasBeenMorphed = uniqueValueKeys.length === 0;

                // set additional options
                vm.addConfig = {};
                var config = lodash.get(vm.options, 'config', {});
                Object.keys(config).forEach(function(configKey) {
                    var subConfig = lodash.get(vm, ["addConfig", configKey].join('.'), {});
                    var currentConfig = angular.copy(lodash.get(config, configKey, {}));

                    vm.addConfig[configKey] = Object.assign(subConfig, currentConfig);
                });

                if (!hasBeenMorphed) {
                    vm.options = lodash.reduce(
                        lodash.get(vm, 'options.data', {}),
                        function (accum, oData, oDataKey) {
                            lodash.set(accum, oDataKey, { data: oData });
                            return accum;
                        },
                        {}
                    );
                }

                lodash.forEach(vm.subFilterKeys, function (subFilterKey) {
                    var innerFilterValueLabelPath = [filterValueLabelPath, subFilterKey].join('.');
                    var innerFilterValueModelPath = [filterValueModelPath, subFilterKey].join('.');
                    var innerSubSettingsPath = [subSettingsPath, subFilterKey, 'select_options', 'selectize'].join('.');
                    var innerSelectizePath = [selectizePath, subFilterKey].join('.');
                    var innerIsLoadingPath = [isLoadingPath, subFilterKey].join('.');
                    var innerConfigPath = [configPath, subFilterKey].join('.');

                    var innerOptionsPath = [optionsPath, subFilterKey].join('.');
                    var options = lodash.get(vm, innerOptionsPath, {});

                    var additionalOptionsPath = ['additionalOptions', subFilterKey].join('.');
                    lodash.setWith(vm, additionalOptionsPath, {}, Object);
                    var additionalOptions = lodash.get(vm, additionalOptionsPath);

                    var _config = lodash.get(vm, ['addConfig', subFilterKey].join('.'), {});
                    FbSelectService.initTemplateCall(Object.assign(options, _config), additionalOptions);

                    var innerDsPath = [dsPath, subFilterKey].join('.');

                    if (lodash.has(options, 'data.datasource') && !lodash.get(options, 'data.datasource.limited', false)) {
                        innerOptionsPath = innerOptionsPath + '.data';
                        loadRemoteData(innerOptionsPath, innerDsPath, innerIsLoadingPath, subFilterKey);
                    } else {
                        if (lodash.has(options, 'data')) {
                            lodash.setWith(vm, innerDsPath, lodash.get(options, 'data'), Object);
                        }
                    }

                    if (lodash.has(options, 'data.datasource') && lodash.get(options, 'data.datasource.limited', false)) {
                        lodash.set(
                            vm,
                            [additionalOptionsPath, 'load'].join('.'),
                            additionalOptionsLoad(innerOptionsPath, innerFilterValueModelPath)
                        );

                        lodash.set(
                            vm,
                            [additionalOptionsPath, 'onInitialize'].join('.'),
                            additionalOptionsOnInitialize(innerSelectizePath)
                        );

                        lodash.set(vm, [additionalOptions, 'maxOptions'].join('.'), 10);
                    }

                    lodash.setWith(vm, innerConfigPath, angular.merge(
                        {
                            highlight: true,
                            create: false,
                            labelField: 'label',
                            valueField: 'value',
                            plugins: ['remove_button'],
                            searchField: ['label'],
                        },
                        lodash.get(vm, additionalOptionsPath, {}),
                        lodash.get(vm, innerSelectizePath, {}),
                        lodash.get(vm, innerSubSettingsPath, {})
                    ), Object);
                });
            } else {
                vm.additionalOptions = {};

                FbSelectService.initTemplateCall(vm.options, vm.additionalOptions);

                vm.ds = [];
                if (lodash.has(vm.options, 'datasource') && !lodash.get(vm.options, 'datasource.limited', false)) {
                    loadRemoteData(optionsPath, dsPath);
                } else {
                    if (lodash.has(vm.options, 'data')) {
                        vm.ds = vm.options.data;
                    }
                }

                if (lodash.has(vm.options, 'datasource') && lodash.get(vm.options, 'datasource.limited', false)) {
                    var prevQuery = '';
                    vm.ds = lodash.get(vm.options, 'data', []);

                    var loadFunc = function(query, callback) {
                        if (typeof query === typeof "string") {
                            if (prevQuery === query)
                                return;
                            prevQuery = query;
                            query = {search: query};
                        } else {
                            return;
                        }

                        query.applied_filter = vm.filterValueModel;

                        var datasource = vm.options.datasource;
                        var model = new GenericModel(datasource.url);
                        var method = lodash.get(vm.options.datasource, 'method', 'get');
                        var params = angular.extend(lodash.get(datasource, 'params', {}), query || {});
                        var request = (method === 'get') ? model[method](params) : model[method]({}, {data:params});

                        return request.$promise.then(function(res) { //res
                            if (res.success && res.status_code == 200) {
                                var data = lodash.get(res, 'data', [])
                                vm.options.data = (vm.options.data || []).concat(
                                    lodash.filter(data, function(_data) {
                                        var value = lodash.get(_data, 'value')
                                        return lodash.findIndex(vm.options.data, { value: value }) < 0;
                                    })
                                );
                                vm.ds = vm.options.data;
                                callback(vm.ds);
                                return;
                            } else {
                                console.warn('Calling ' + vm.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                                return callback([]);
                            }
                        }, function(res) {
                            console.warn('Calling ' + vm.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                            console.warn(res); // eslint-disable-line no-console
                            return callback([]);
                        });
                    };
                    var loadDebounceFunc = lodash.debounce(loadFunc, 300);
                    vm.additionalOptions.load = loadDebounceFunc;
                    vm.additionalOptions.onInitialize = function(selectize) {
                        vm.selectize = selectize;
                        $timeout(function() {
                            selectize.onSearchChange({});
                        });

                    }
                    // vm.additionalOptions.maxOptions = 10;

                    $scope.$watch(
                        function() { return vm.filterValueModel; },
                        function(newValue, oldValue) {
                            loadDebounceFunc(newValue, function() {});
                        });
                }


                vm.config = angular.merge(
                    {
                        highlight: true,
                        create: false,
                        labelField: 'label',
                        valueField: 'value',
                        plugins: ['remove_button'],
                        searchField: ['label'],
                    },
                    vm.additionalOptions,
                    vm.options.selectize || {}
                );
            }
        }

        function additionalOptionsOnInitialize(selectizePath) {
            return function(selectize) {
                lodash.set(vm, selectizePath, selectize)
                $timeout(function () {
                    selectize.onSearchChange({});
                });
            }
        }

        function additionalOptionsLoad(optionsPath, filterValueModelPath) {
            return function (query, callback) {
                if (typeof query === typeof "string") {
                    query = { search: query };
                }
                lodash.set(query, 'applied_filter', lodash.get(vm, filterValueModelPath));

                var datasource = lodash.get(vm, [optionsPath, 'datasource'].join('.'));
                var model = new GenericModel(lodash.get(datasource, 'url'));
                var method = lodash.get(datasource, 'method', 'get')

                var params = angular.extend(lodash.get(datasource, 'params', {}), query || {});
                var request = (method === 'get') ? model[method](params) : model[method]({}, { data: params });

                return request.$promise.then(function (res) {
                    if (res.success && res.status_code == 200) { //res
                        return callback(res.data);
                    }
                    else {
                        console.warn('Calling ' + lodash.get(datasource, 'url') + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                        return callback([]);
                    }
                }, function (res) {
                    console.warn('Calling ' + lodash.get(datasource, 'url') + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    console.warn(res); // eslint-disable-line no-console
                    return callback([]);
                });
            }
        }

        function loadRemoteData(optionsPath, dsPath, isLoadingPath, subFilterKey) {
            if (lodash.has(vm, optionsPath, 'datasource.url')) {
                 lodash.set(vm, isLoadingPath, true);

                var callRemoteApiPromise = callRemoteApi(optionsPath);
                callRemoteApiPromise.then(function (res) {
                    if ($filter('isMultipleEnumType')(vm.type)) {
                        lodash.setWith(vm, dsPath, res, Object);

                        var _subSetting = lodash.get(vm, ['subSettings', subFilterKey].join('.'), {});
                        var isAutoFirst = lodash.get(_subSetting, 'auto_first');
                        if (isAutoFirst) {
                            var firstItem = lodash.first(res);
                            var firstItemValue = lodash.get(firstItem, 'value');
                            lodash.setWith(vm, ['filterValueModel', subFilterKey].join('.'), firstItemValue, Object);
                        }
                    } else {
                        lodash.set(vm, dsPath, res);
                    }
                    // Fix ENUM REMOTE
                    lodash.set(vm, [optionsPath, 'data'].join('.'), lodash.get(vm, dsPath));
                    lodash.set(vm, isLoadingPath, false);
                });
            }
        }

        function callRemoteApi(optionsPath) {
            var datasource = lodash.get(vm, [optionsPath, 'datasource'].join('.'));

            var model = new GenericModel(lodash.get(datasource, 'url'));
            var method = lodash.get(datasource, 'method', 'get');

            // var data = {};
            // if (!lodash.get(options, 'data.datasource.limited', false)) {
            //
            // }

            return model[method]({}, {})
                .$promise.then(
                    function (res) { //res
                        if (res.success && res.status_code == 200) {
                            return res.data;
                        } else {
                            console.warn('Calling ' + lodash.get(datasource, 'url') + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                            return null;
                        }
                    }, function (res) {
                        console.warn('Calling ' + lodash.get(datasource, 'url') + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                        console.warn(res); // eslint-disable-line no-console
                        return null;
                    }
                );
        }
    }
})();

